import { FC, useEffect, useContext, useState, useLayoutEffect } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { format } from "date-fns";


import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";

import FooterText from "src/components/footerText";
// import CaseVolume from "src/components/manufacturer/caseVolumeLineChart";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
import { CaseListingType, StatisticsApiResponse } from "../manufacturer/types";
import CustomPieChart from "src/components/manufacturer/customPieChart";
import CaseDetail from "src/components/manufacturer/caseDetail";
import { TerritoriesSearchProps } from "src/components/manufacturer/territoriesFilter/types";
import TerritoriesFilter from "src/components/manufacturer/territoriesFilter";
import CustomLineChart from "src/components/manufacturer/customLineChart";


const DoctorStats: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const [searchParams] = useSearchParams();
  const { docId } = useParams();
  const {role, id,p_id} = useParams ();

   
    
    console.log("role", { role })
    console.log("id", { id })
    console.log("p_id", { p_id })
  
  const [queryParams,changeQueryParams] = useState({
    start_date: searchParams.get('start_date') || format((new Date()).setDate((new Date()).getDate() - 30), "yyyy-MM-dd"),
    end_date: searchParams.get('end_date') || format((new Date()).setDate((new Date()).getDate()), "yyyy-MM-dd"),
    period: searchParams.get('period') || "",
    filter: searchParams.get('filter') || "",
    time: searchParams.get('time') || "",
    type: searchParams.get('type') || "",
    role: searchParams.get('role') || "",
    id: Number(docId) || 0,
    case_id: "",
    search_str: "",
    p_id: Number(searchParams.get('p_id')) || 0,
  });

  const { data: statisticsData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);

  useLayoutEffect(() => setLoader(), [])

  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);



  const updateQueryParamsAndCallAPI = (updatedQueries: TerritoriesSearchProps, isReset: boolean = false): void => {
    if (isReset) {
      changeQueryParams({
        start_date: format((new Date()).setDate((new Date()).getDate() - 30), "yyyy-MM-dd"),
        end_date: format((new Date()).setDate((new Date()).getDate()), "yyyy-MM-dd"),
        period: "",
        filter: "",
        time: "",
        type: "",
        id: 0,
        role: '',
        case_id:'',
        search_str: "",
        p_id: 0,
      });
    } else {
      changeQueryParams(updatedQueries);
    }

    setLoader()
    getStatsData({}, {}, updatedQueries);
  };

  // const getStatisticsData = () => {
  //   const updatedQueries = {
  //     ...queryParams,

  //   }
  //   changeQueryParams(updatedQueries)
  //   getStatsData({}, {}, updatedQueries);
  // }

  return (
    <div className="container-fluid overflow-auto">
      <AuthMaunfacturerSubHeader />
    
        <TerritoriesFilter
          defaultQueryParams={queryParams}
          updateQueryParams={updateQueryParamsAndCallAPI}
        />
      
      {statisticsData && statisticsData.data && statisticsData.data.case_volume && (
        <CustomLineChart title="Case Volume"
          LineChartObject={statisticsData.data.case_volume} />
      )}

      {statisticsData && (
        <div className="row mt-3">
          <div className="col-12 col-md-6 mb-3">
            <CustomPieChart pieChartObject={statisticsData.data.top_payors} title={'Top 10 Payors'} />
          </div>
          <div className="col-12 col-md-6">
            <CustomPieChart pieChartObject={statisticsData.data.mos} title={'Cases By Submission Mode'} />
          </div>
        </div>
      )}

    <div className="row">
        <div className="mt-3">
          {statisticsData && <CaseDetail baseUrl="/statistics" searchParams={queryParams} CaseDetailListType={statisticsData.data.case_listing as unknown as CaseListingType[]} />}
        </div>
      </div>

      <FooterText footerType="black" />
    </div>
  );
};

export default DoctorStats;
